import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import {
  CONTAINS,
  DOESNT_CONTAIN,
  DOESNT_MATCH,
  EMAIL,
  // ITextFieldRule,
  MATCHES,
  NUMBER,
  NUMBER_VALUE_EQUAL,
  NUMBER_VALUE_GREATER_THAN,
  NUMBER_VALUE_GREATER_THAN_AND_EQUAL,
  DIGIT_COUNT,
  VALUE_SHOULD_BE_BETWEEN,
  NUMBER_VALUE_LESS_THAN,
  NUMBER_VALUE_LESS_THAN_AND_EQUAL,
  PHONE_NUMBER,
  REGULAR_EXPRESSION,
  TEXT,
  TEXT_CONTAINS,
  TEXT_DOES_NOT_CONTAINS,
  TEXT_EQUAL,
  TEXT_MAX_LENGTH,
  URL,
  IFieldRuleConfig,
  FieldRulesDetails,
  SUFFIX_CONTAINS_RULE,
  PREFFIX_CONTAINS_RULE,
} from "@presentation/FormBuilder/Rules/config";
import { validateSubRule } from "@presentation/FormBuilder/utils";
import { FieldProps } from "../../FormFieldSelector/interfaces";
import { FormHelper } from "@utils/FormHelper";

export const getInitialRuleConfigTextInput = (
  rule: string
): IFieldRuleConfig => {
  const ruleDetails = FieldRulesDetails[rule];

  switch (rule) {
    case TEXT:
    case NUMBER:
    case EMAIL:
    case PHONE_NUMBER:
    case URL:
    case REGULAR_EXPRESSION:
      return {
        rule,
        value: undefined,
        errorMessage: ruleDetails.defaultErrorMessage || "",
      };
    case TEXT_EQUAL:
    case TEXT_CONTAINS:
    case TEXT_DOES_NOT_CONTAINS:
    case TEXT_MAX_LENGTH:
    case NUMBER_VALUE_EQUAL:
    case NUMBER_VALUE_LESS_THAN:
    case NUMBER_VALUE_LESS_THAN_AND_EQUAL:
    case NUMBER_VALUE_GREATER_THAN:
    case NUMBER_VALUE_GREATER_THAN_AND_EQUAL:
    case DIGIT_COUNT:
    case CONTAINS:
    case DOESNT_CONTAIN:
    case MATCHES:
    case DOESNT_MATCH:
    case SUFFIX_CONTAINS_RULE:
    case PREFFIX_CONTAINS_RULE:
      return {
        rule,
        value: "",
        errorMessage: ruleDetails.defaultErrorMessage || "",
      };
    default:
      return {
        rule,
        value: "",
        errorMessage: "",
      } as IFieldRuleConfig;
  }
};

export const validateTextInputFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.value) || "";
  if (isRequired && !!isVisible) {
    //validateFieldValue not used anywhere
    if (!submissionValue) {
      return [false, "This is a Required Field"];
    }
  }

  if (fieldRules && submissionValue) {
    for (let i = 0; i < fieldRules?.length; i++) {
      const [isValidated, validatationErrorMessage] = validateRule(
        fieldRules[i],
        submissionValue,
        fieldSubmissionMap
      );

      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  } else if (fieldRules?.length > 0 && isRequired) {
    return [false, "This is a Required Field"];
  }

  return [true, ""];
};

export const validateRule = (
  fieldRule: IFieldRuleConfig,
  submissionValue: any,
  fieldSubmissionMap?: IFieldSubmissionMap
): [boolean, string] => {
  const { rule, value, errorMessage } = fieldRule;
  const ruleType: string = rule;
  let ruleValue: any = `${value}`;
  const ruleErrorValue: string = errorMessage;

  const isDynamicValue = fieldRule?.valueType == "dynamic";
  const dynamicValueFieldId = fieldRule?.dynamicValueFieldId;
  if (isDynamicValue && !dynamicValueFieldId) {
    return [true, ""];
  }
  const dynamicFieldData = fieldSubmissionMap[dynamicValueFieldId];
  if (isDynamicValue && !dynamicFieldData) {
    return [true, ""];
  }
  const dynamicFieldValue = `${dynamicFieldData?.fieldSubmissionValue?.value}`;
  if (isDynamicValue && dynamicFieldData) {
    ruleValue = dynamicFieldValue;
  }

  switch (ruleType) {
    case TEXT_EQUAL:
      if (ruleValue != submissionValue) return [false, ruleErrorValue];
      break;
    case TEXT_CONTAINS:
      if (
        typeof ruleValue === "string" &&
        !submissionValue?.includes(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case TEXT_DOES_NOT_CONTAINS:
      if (typeof ruleValue === "string" && submissionValue?.includes(ruleValue))
        return [false, ruleErrorValue];
      break;
    case TEXT_MAX_LENGTH:
      if (
        typeof ruleValue === "string" &&
        submissionValue?.length > parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case NUMBER_VALUE_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) != parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case NUMBER_VALUE_LESS_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) >= parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case NUMBER_VALUE_LESS_THAN_AND_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) > parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case NUMBER_VALUE_GREATER_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) <= parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case NUMBER_VALUE_GREATER_THAN_AND_EQUAL:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) < parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case DIGIT_COUNT:
      if (
        typeof ruleValue === "string" &&
        submissionValue?.toString()?.length !== parseInt(ruleValue)
      )
        return [false, ruleErrorValue];
      break;
    case VALUE_SHOULD_BE_BETWEEN:
      if (
        (parseInt(submissionValue) < parseInt(ruleValue?.min) &&
          ruleValue?.isIncludeMin) ||
        (parseInt(submissionValue) > parseInt(ruleValue?.max) &&
          ruleValue?.isIncludeMax)
      )
        return [false, ruleErrorValue];
      break;
    case CONTAINS:
      if (ruleValue && typeof ruleValue === "string") {
        const regEx = new RegExp(ruleValue);
        if (regEx.test(submissionValue)) {
          return [false, ruleErrorValue];
        }
      }
      break;
    case DOESNT_CONTAIN:
      if (ruleValue && typeof ruleValue === "string") {
        const regEx = new RegExp(ruleValue);
        if (!regEx.test(submissionValue)) {
          return [false, ruleErrorValue];
        }
      }
      break;

    case MATCHES:
      if (ruleValue && typeof ruleValue === "string" && ruleValue.trim() !== "") {
        const regEx = new RegExp(ruleValue.trim()); //  '^[a-zA-Z]+$'
        if (!regEx.test(submissionValue)) {
          return [false, ruleErrorValue];
        }
      }
      break;
    case DOESNT_MATCH:
      if (ruleValue && typeof ruleValue === "string") {
        const regEx = ruleValue; //  '^[a-zA-Z]+$'
        if (regEx.search(submissionValue) != -1) {
          return [false, ruleErrorValue];
        }
      }
      break;
    case EMAIL:
      const regExEmail =
        /^[A-Za-z0-9_+-]+(\.[A-Za-z0-9_+-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
      if (!regExEmail.test(submissionValue)) {
        return [false, ruleErrorValue];
      }
      break;

    case PHONE_NUMBER:
      const regExPhone1 = /^[0-9]{10}$/; //plain number
      const regExPhone2 = /^(0[1-9][0-9]{8,10})$/; //With 0
      const regExPhone3 = /^\+\d{12,15}$/; // With country code
      let isValidated = false;
      if (regExPhone1.test(submissionValue)) {
        isValidated = true;
      } else if (regExPhone2.test(submissionValue)) {
        isValidated = true;
      } else if (regExPhone3.test(submissionValue)) {
        isValidated = true;
      }
      if (!isValidated) {
        return [false, ruleErrorValue];
      }
      break;

    case URL:
      if (!FormHelper.isURL(submissionValue)) {
        return [false, ruleErrorValue];
      }

      break;

    case TEXT:
      const regExText = /^[a-zA-Z\s-, ]+$/;
      if (!regExText.test(submissionValue)) {
        return [false, ruleErrorValue];
      }

      break;

    case NUMBER:
      const regExNumber = /^[0-9]+$/;
      if (!regExNumber.test(submissionValue)) {
        return [false, ruleErrorValue];
      }
      break;

    case SUFFIX_CONTAINS_RULE:
      if (ruleValue) {
        const prefix = ruleValue;
        if (!submissionValue.endsWith(prefix)) {
          return [false, ruleErrorValue];
        }
      }
      break;

    case PREFFIX_CONTAINS_RULE:
      if (ruleValue) {
        const prefix = ruleValue;
        if (!submissionValue.startsWith(prefix)) {
          return [false, ruleErrorValue];
        }
      }
      break;

    default:
      break;
  }

  if (fieldRule?.subRules?.length > 0) {
    const [isValidated, validatationErrorMessage] = validateSubRule(
      fieldRule,
      submissionValue,
      fieldSubmissionMap,
      validateRule
    );
    return [isValidated, validatationErrorMessage];
  }

  return [true, ""];
};

// const getUpdatedRuleValue = (fieldRule: IFieldRuleConfig, fieldSubmissionMap: IFieldSubmissionMap, value:FieldRuleValueConfig) => {
//   const ruleValue: any = `${value}`;
//   const isDynamicValue = fieldRule?.valueType == "dynamic";
//   const dynamicValueFieldId = fieldRule?.dynamicValueFieldId;
//   if (isDynamicValue && !dynamicValueFieldId) {
//     return [true, ""]
//   }
//   const dynamicFieldData = fieldSubmissionMap[dynamicValueFieldId];
//   if (isDynamicValue && !dynamicFieldData) {
//     return [true, ""]
//   }
//   const dynamicFieldValue = `${dynamicFieldData?.fieldSubmissionValue?.value}`
//   if (isDynamicValue && dynamicFieldData) {
//     return dynamicFieldValue;
//   }
// }
